import { GetTimeRequestResponse, ErrorResponse } from "utils/interfaces"
import { waitForFieldUpdate } from "modules/BookingCommon/common/waitForFieldUpdate"
import { TIME_REQUEST_STATUSES } from "utils/constants"
import { httpClient } from "utils/infrastructure/httpClient"

export function getTimeRequest(hash: string) {
    return httpClient
        .get<GetTimeRequestResponse & ErrorResponse>(`time-request/get/${hash}`)
        .then((data) => {
            if (data.error) {
                throw new Error(data.error)
            }
            return data
        })
}
export function waitTimeRequestStatusUpdate(
    hash: string,
    currentStatus: string
): Promise<GetTimeRequestResponse & ErrorResponse> {
    return waitForFieldUpdate({
        errorText:
            "Статус запроса не изменился за 2 минуты. Попробуйте обновить страницу или свяжитесь с поддержкой",
        isEqual: (last, current) => last.status === current.status,
        current: { status: currentStatus as TIME_REQUEST_STATUSES },
        promiseFactory: () => getTimeRequest(hash),
    })
}
